import React, { ReactNode } from 'react';
import moment from 'moment';
import { formatCurrency } from 'utils';
import { PartnerProposalDashboardEntity, PartnerProposalTableSortingFields } from './types';
import { DateFormats } from '../../../../../../constants/common';
import { ActionCell, DealTypeCell, StatusCell } from '../../../../../proposals/ui/tables/cells';

export function generateColumns(
  handleGoToProposal: (proposal: PartnerProposalDashboardEntity) => void,
  handleGoToProposalDetail: (proposal: PartnerProposalDashboardEntity) => void
): {
  label: string;
  footer?: React.ReactNode;
  formatter?: (value: any) => ReactNode;
  sortKey?: PartnerProposalTableSortingFields;
  renderKey: keyof PartnerProposalDashboardEntity;
  bodyFormatter?: (value: any, proposal: PartnerProposalDashboardEntity) => ReactNode;
}[] {
  return [
    {
      footer: 'Totals',
      label: 'Created On',
      renderKey: 'createdDateTime',
      sortKey: 'created_date_time',
      bodyFormatter: value => moment(value).format(DateFormats.DateTimeShort12Hour),
    },
    {
      label: 'Dealer',
      renderKey: 'dealer',
    },
    {
      label: 'Company',
      renderKey: 'company',
      sortKey: 'business_name',
    },
    {
      label: 'Contact',
      renderKey: 'contact',
      sortKey: 'first_name',
    },
    {
      label: 'Amount',
      renderKey: 'amountRequested',
      sortKey: 'amount_requested',
      bodyFormatter: amount => formatCurrency(amount, true),
    },
    {
      label: 'Proposal Status',
      sortKey: 'status',
      renderKey: 'status',
      bodyFormatter: (_, proposal) => <StatusCell proposal={proposal} />,
    },
    {
      label: 'Deal Type',
      renderKey: 'dealType',
      bodyFormatter: type => <DealTypeCell type={type} />,
    },
    {
      label: 'Actions',
      renderKey: 'id',
      bodyFormatter: (_, proposal) => (
        <ActionCell
          proposal={proposal}
          onGoToProposal={handleGoToProposal}
          onGoToProposalDetail={handleGoToProposalDetail}
        />
      ),
    },
  ];
}
